import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { RecapitoDTO } from "../anagrafe/recapitoDTO";

export class DestinatarioDTO extends RecapitoDTO {

  tipoDestinatario: TipoDestinatarioEnum;
  invio: boolean = true;
  idSoggetto: string;
  idRecapito: string;
  denominazioneSoggetto: string;
  denominazioneRecapito: string;
}